import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { ListFieldSection, SectionGroup } from '../../../../../Layout';

let AsLiquidLimitOnePointDeterminationSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('LiquidLimit.NonPlastic'), valueOrDefault(false), (np) => !np)
  );
  return (
    <>
      <SectionGroup heading="Result">
        <ListFieldSection>
          {determinationPerformed ? (
            <Field input={<TextOutput />} name="LiquidLimit.LiquidLimit" />
          ) : (
            <Field input={<TextOutput />} name="Results.LiquidLimitText" />
          )}
        </ListFieldSection>
      </SectionGroup>
    </>
  );
};

AsLiquidLimitOnePointDeterminationSection = withInjectedProps(AsLiquidLimitOnePointDeterminationSection);

export { AsLiquidLimitOnePointDeterminationSection };
export default AsLiquidLimitOnePointDeterminationSection;
